/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AddStoreReviewDto } from '../../models/add-store-review-dto';
import { StoreReviewDto } from '../../models/store-review-dto';

export interface CreateStoreReview$Params {
      body: AddStoreReviewDto
}

export function createStoreReview(http: HttpClient, rootUrl: string, params: CreateStoreReview$Params, context?: HttpContext): Observable<StrictHttpResponse<StoreReviewDto>> {
  const rb = new RequestBuilder(rootUrl, createStoreReview.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<StoreReviewDto>;
    })
  );
}

createStoreReview.PATH = '/api/v1/store-reviews';
